import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const PaymentPlanSummaryLabel = ({ isMobile, children }: { isMobile: boolean; children: React.ReactNode }) => {
  if (isMobile) {
    return <Text color='subdued'>{children}</Text>;
  }

  return (
    <Text
      weight='semibold'
      css={css`
        font-size: ${theme.fontSize(14)};
        color: ${theme.colors.neutral60};
      `}
    >
      {children}
    </Text>
  );
};
